import { Component, Input, OnInit, AfterViewInit, OnDestroy,ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../services/common.service';
import beautify from "xml-beautifier";
import { DiffEditorModel } from 'ngx-monaco-editor-v2';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';

declare const copyToClipboard: (text: string) => void;

// PinnedMessage interface definition
export interface PinnedMessage {
  messageId: string;
  routeGuid: string;
  routeName?: string;
  pinName?: string;
  reason?: string;
  messageData?: any;
  pinnedDate?: Date;
}
@Component({
  selector: 'app-compare-pinned',
  templateUrl: './compare-pinned.component.html',
  styleUrls: ['./compare-pinned.component.scss']
})
export class ComparePinnedComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() selectedMessage: any; // Current message selected for comparison
  @Input() routeGuid: string;
  @Input() routeName: string;
  @Input() archivedbcheck: boolean = false; // Archive database check flag from hubmessages
  @Input() messagedata: any; // Message data passed from hubmessages component


  pinnedMessages: PinnedMessage[] = [];
  pinnedMessageList: any[] = []; // Formatted list for ng-autocomplete
  pinnedMessageAllList: any[] = []; // All pinned messages for filtering
  selectedPinnedMessage: PinnedMessage | null = null;
  isLoadingPinnedMessages: boolean = false;
  selectedpin: PinnedMessage | null = null;
  reactiveFormPinnedMessage: FormGroup;
  keywordsearchPinned = "displayname";
  notfounddataPinned: boolean = false;
  messageArray = [];
  firstFileMessageId: string = "";
  secondFileMessageId: string = "";
  filedataListArray: any[] = [];
   public reactiveFormmsgtype: FormGroup;
   messageTypeList: any = [];
   messageTypeAllList: any = [];
   keywordsearch = "displayname";
   isLoadingmessagetype: boolean = false;
    notfounddata: boolean;

  // Left pane - selected message
  left: string = '';

  // Right pane - pinned message
  right: string = '';

  // Store raw data for both messages to switch between InputData and TransformedData
  leftMessageData: any = null;
  rightMessageData: any = null;

  // Radio button selection: 'input' for InputData, 'transformed' for TransformedData
  dataType: string = 'transformed';

  formatType: string = 'text/plain';

  oldModel: DiffEditorModel = {
    code: '',
    language: this.formatType
  };

  newModel: DiffEditorModel = {
    code: '',
    language: this.formatType
  };

  diffOptions = {
    theme: "vs",
    language: this.formatType,
    readOnly: true,
    lineNumbers: true,
    wordWrap: 'on',
    renderSideBySide: true,
    scrollBeyondLastLine: false
  };

  islinebyline: boolean = false;
  private subscriptions: Subscription[] = [];

  constructor(
    private activeModal: NgbActiveModal,
    private service: CommonService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private toastr: ToastrService,
    private _fb: FormBuilder
  ) {
    this.reactiveFormPinnedMessage = this._fb.group({ namepinned: "" });
    this.reactiveFormmsgtype = this._fb.group({ msgname: '' });
  }

  async ngOnInit() {
    this.loadPinnedMessages();
    this.loadSelectedMessageData();
    await this.GetContentByMessageId(this.messagedata);
  }

  ngAfterViewInit() {
    // Auto-select first pinned message if available
    if (this.pinnedMessageList.length > 0 && !this.selectedpin) {
      setTimeout(() => {
        const firstMessage = this.pinnedMessageList[0];
        this.selectedPinnedMessageEvent(firstMessage);
      }, 100);
    }
  }

 ngOnDestroy() {
    // Clean up subscriptions to prevent memory leaks
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  closeModal() {
    this.activeModal.close();
  }

  // Load pinned messages for the route
  loadPinnedMessages(): void {
    if (!this.routeGuid) {
      return;
    }
    this.ngxUiLoaderService.start();
    this.isLoadingPinnedMessages = true;
    const subscription = this.service.getPinnedMessages(this.routeGuid).subscribe(
      (response: any) => {
         //this.ngxUiLoaderService.stop();
        this.isLoadingPinnedMessages = false;
        // Check if response has responsebody array (from Getpinnedmessages API)
        if (response && response.responsebody && Array.isArray(response.responsebody)) {
          this.pinnedMessages = response.responsebody.map(msg => ({
            messageId: msg.messageId || msg.messageid,
            routeGuid: msg.routeGuid || this.routeGuid,
            routeName: msg.routeName || this.routeName,
            pinName: msg.pinName || msg.fileName || msg.filename || '',
            reason: msg.reason || '',
            messageData: msg,
            pinnedDate: msg.pinnedAt ? new Date(msg.pinnedAt) : new Date()
          }));
        } 
        // else if (response && Array.isArray(response)) {
        //   // Fallback: if response is directly an array
        //   this.pinnedMessages = response.map(msg => ({
        //     messageId: msg.messageId || msg.messageid,
        //     routeGuid: this.routeGuid,
        //     routeName: msg.routeName || this.routeName,
        //     pinName: msg.pinName || msg.fileName || msg.filename || '',
        //     reason: msg.reason || '',
        //     messageData: msg,
        //     pinnedDate: msg.pinnedDate || msg.pinnedAt ? new Date(msg.pinnedDate || msg.pinnedAt) : new Date()
        //   }));
        // } 
        else {
          this.pinnedMessages = [];
        }

        // Transform pinnedMessages to ng-autocomplete format
        this.pinnedMessageAllList = this.pinnedMessages.map(msg => ({
          id: msg.messageId,
          displayname: msg.pinName || msg.messageId || '',
          messageId: msg.messageId,
          routeGuid: msg.routeGuid,
          routeName: msg.routeName,
          pinName: msg.pinName,
          reason: msg.reason,
          messageData: msg.messageData,
          pinnedDate: msg.pinnedDate,
          originalMessage: msg // Keep reference to original PinnedMessage
        }));

        // Initialize list for autocomplete
        this.pinnedMessageList = this.pinnedMessageAllList;

        // Auto-select the first pinned message if available
        // Use setTimeout to ensure ng-autocomplete is ready to receive the value
        if (this.pinnedMessageList.length > 0) {
          setTimeout(() => {
            this.selectedPinnedMessageEvent(this.pinnedMessageList[0]);
          }, 100);
        }
      },
      error => {
         this.ngxUiLoaderService.stop();
        this.isLoadingPinnedMessages = false;
        this.toastr.error('Failed to load pinned messages', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }
    );
  }

  // Load data for the selected message (left pane)
  loadSelectedMessageData(): void {
    if (!this.selectedMessage) {
      return;
    }

    const messageId = this.selectedMessage.messageid || this.selectedMessage.handler;
    if (!messageId) {
      return;
    }

    // Load message IOT data
    const subscription = this.service.Hubmessage_IOTData(
      this.selectedMessage.id || this.selectedMessage.fileid,
      this.selectedMessage.fileid || this.selectedMessage.messagepayloadreference,
      this.archivedbcheck
    ).subscribe(
      data => {
        if (data) {
          this.leftMessageData = data;
          this.processMessageData(data, 'left');
        }
      },
      error => {
        this.ngxUiLoaderService.stop();
        this.toastr.error('Failed to load message data', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }
    );
    this.subscriptions.push(subscription);
  }

  // Handle pinned message selection from ng-autocomplete
  async selectedPinnedMessageEvent(item: any): Promise<void> {
    if (!item || !item.originalMessage) {
      return;
    }
    this.selectedpin = item.originalMessage;
    this.selectedPinnedMessage = item.originalMessage;
    const displayName = item.displayname || item.pinName || item.messageId || '';

    // Set the form control value asynchronously to display selected value
    // Use setTimeout to avoid blocking and allow input to remain editable
    setTimeout(() => {
      this.reactiveFormPinnedMessage.patchValue({ namepinned: displayName }, { emitEvent: false });
    }, 0);

    // Run async operation without blocking - allows input to remain editable
    this.onPinnedMessageSelected().catch(error => {
      console.error('Error loading pinned message:', error);
    });
  }

  // Handle input change for pinned message search
  getPinnedMessageName(event: any): void {
    if (!event || event === '') {
      this.pinnedMessageList = [...this.pinnedMessageAllList];
      this.notfounddataPinned = false;
      return;
    }
    // Don't patch form during typing - let autocomplete manage the form control naturally
    // This allows user to continue typing without interference
    const searchLower = ('' + event).toLowerCase();
    this.pinnedMessageList = this.pinnedMessageAllList.filter(msg => {
      const displayName = (msg.displayname || '').toLowerCase();
      const messageId = (msg.messageId || '').toLowerCase();
      return displayName.includes(searchLower) || messageId.includes(searchLower);
    });
    if (this.pinnedMessageList.length === 0) {
      this.notfounddataPinned = true;
    } else {
      this.notfounddataPinned = false;
    }
  }

  // Handle input cleared for pinned message search
  searchPinnedMessageCleared(event: any): void {
    this.isLoadingPinnedMessages = false;
    this.pinnedMessageList = [...this.pinnedMessageAllList];
    this.selectedpin = null;
    this.selectedPinnedMessage = null;
    this.notfounddataPinned = false;
    // Clear the form control to allow fresh search
    this.reactiveFormPinnedMessage.patchValue({ namepinned: '' }, { emitEvent: false });
    this.right = '';
    this.updateEditorDiffData();
  }

  // Get display string for pinned message (for highlighting search terms)
  getPinnedMessageDisplay(displayname: string): string {
    return displayname || '';
  }

  // Handle pinned message selection
  async onPinnedMessageSelected() {
    this.selectedPinnedMessage = this.selectedpin;

    if (!this.selectedpin) {
      this.right = '';
      this.updateEditorDiffData();
      // Clear second message card
      if (this.messageArray[1]) {
        this.messageArray[1] = {};
        this.messageArray[1].attributes = [];
      }
      return;
    }

    this.right = '';

    // Get messageId from pinned message
    const messageId = this.selectedpin.messageId;

    if (!messageId) {
      this.toastr.error('Message ID not available', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      return;
    }

    // Update second message card with pinned message data using getsearchdetails
    // This also returns id and fileId from the GetSearchDetails response
    this.secondFileMessageId = messageId;
    const { id, fileId } = await this.loadSecondMessageCardData(messageId);

    // Validate that id and fileId were retrieved from GetSearchDetails
    if (!fileId || !id) {
      this.ngxUiLoaderService.stop();
      this.toastr.error('File ID or ID not found for message', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      return;
    }

    // Get input transform output data using Hubmessage_IOTData endpoint
    // Use id as uniqueid (first parameter) and fileId as payloadreference (second parameter)
    this.ngxUiLoaderService.start();
    const iotSubscription = this.service.Hubmessage_IOTData(
      id,
      fileId,
      this.archivedbcheck
    ).subscribe(
      data => {
        if (data) {
          this.rightMessageData = data;
          this.processMessageData(data, 'right');
        } else {
          this.ngxUiLoaderService.stop();
          this.toastr.error('No data found for pinned message', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
        }
      },
      error => {
        this.ngxUiLoaderService.stop();
        this.toastr.error('Failed to load pinned message data', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }
    );
    this.subscriptions.push(iotSubscription);
  }

  // Process message data (input formatting)
  processMessageData(data: any, side: 'left' | 'right'): void {
    let messageData = this.getRawMessageData(data);
    messageData = this.formatMessageData(messageData);
    
    if (messageData) {
      this.determineAndSetFormatType(messageData);
    }

    if (side === 'left') {
      this.left = messageData;
    } else {
      this.right = messageData;
    }
    this.updateEditorDiffData();
    this.ngxUiLoaderService.stop();
  }

  // Get raw message data based on dataType selection
  private getRawMessageData(data: any): string {
    return this.dataType === 'transformed'
      ? (data.TransformedData || '')
      : (data.InputData || '');
  }

  // Format message data (JSON/XML)
  private formatMessageData(messageData: string): string {
    if (messageData && this.service.IsJsonString(messageData)) {
      return JSON.stringify(JSON.parse(messageData), null, 2);
    }

    if (messageData && this.IsValidXML(messageData)) {
      return beautify(messageData);
    }

    return messageData;
  }

  // Determine and set format type based on message content
  private determineAndSetFormatType(messageData: string): void {
    if (messageData.startsWith('<')) {
      this.formatType = 'xml';
    } else if (messageData.startsWith('{') || messageData.startsWith('[')) {
      this.formatType = 'json';
    } else if (messageData.includes('MSH|')) {
      this.formatType = 'hl7';
    } else {
      this.formatType = 'text/plain';
    }

    // Update diff options language
    this.diffOptions = { ...this.diffOptions, language: this.formatType };
  }

  // Handle radio button change for data type selection
  onDataTypeChange(event: any): void {
    this.dataType = event.value;
    this.ngxUiLoaderService.start();

    // Re-process both messages with the new data type selection
    if (this.leftMessageData) {
      this.processMessageData(this.leftMessageData, 'left');
    }
    if (this.rightMessageData) {
      this.processMessageData(this.rightMessageData, 'right');
    }

    // Stop loading after processing
    this.ngxUiLoaderService.stop();
  }

  // Update editor diff data
  updateEditorDiffData(): void {
    this.oldModel = { ...this.oldModel, code: this.left, language: this.formatType };
    this.newModel = { ...this.newModel, code: this.right, language: this.formatType };
  }

  // Toggle side-by-side vs line-by-line
  istogglechanged(value): void {
    this.islinebyline = value.checked;
    this.diffOptions = { ...this.diffOptions, renderSideBySide: !this.islinebyline };
  }

  IsValidXML(data: string): boolean {
    try {
      (new DOMParser()).parseFromString(data, 'text/xml');
      return true;
    } catch {
      return false;
    }
  }

  async GetContentByMessageId(messageValue) {
    this.messageArray = messageValue.messagedata;

    // Attach attributes to first message
    if (messageValue.firstentitysearchdata) {
      this.messageArray[0].attributes = messageValue.firstentitysearchdata;
    } else {
      this.messageArray[0].attributes = [];
    }

    this.firstFileMessageId = this.messageArray[0].messageid;

    // Initialize second message card - will be populated when pinned message is selected
    if (!this.messageArray[1]) {
      this.messageArray[1] = {};
    }
    this.messageArray[1].attributes = [];

    // Load first message file content only
    // Second message card and file content will be loaded when pinned message is selected
    this.filedataListArray = [];
    const firstjob = {
      stagevlaue: messageValue.stagevlaue,
      messageid: this.messageArray[0].messageid,
      messagetype: this.messageArray[0].messagetype
    };
    this.filedataListArray.push(firstjob);
  }

  // Load second message card data using getsearchdetails endpoint
  // Returns { id, fileId } from the response for use in Hubmessage_IOTData call
  async loadSecondMessageCardData(messageId: string): Promise<{ id: string | null, fileId: string | null }> {
    if (!messageId) {
      return { id: null, fileId: null };
    }

    try {
      const response = await this.fetchSearchDetails(messageId);
      if (!this.hasValidResponse(response)) {
        return this.handleNoDataFound();
      }

      const messageStatusList = response.hubmessagedata[0];
      const { id, fileId } = this.extractIdAndFileId(messageStatusList);
      
      this.initializeMessageArrayItem();
      this.mapMessageStatusToArray(messageStatusList, messageId);
      this.processEntitySearches(response);

      return { id, fileId };
    } catch (error) {
      return this.handleError();
    }
  }

  // Fetch search details from API
  private async fetchSearchDetails(messageId: string): Promise<any> {
    const searchData = {
      messageid: messageId,
      archivedbcheck: this.archivedbcheck,
      pagenumber: 1,
      pagesize: 1
    };
    const apiname = "api/HubMessage/GetSearchDetails";
    return await this.service.searchpostapi(apiname, searchData);
  }

  // Check if response has valid hubmessagedata
  private hasValidResponse(response: any): boolean {
    return response && response.hubmessagedata && response.hubmessagedata.length > 0;
  }

  // Extract id and fileId from messageStatusList
  private extractIdAndFileId(messageStatusList: any): { id: string | null, fileId: string | null } {
    const id = messageStatusList.id || messageStatusList.Id || null;
    const fileId = messageStatusList.fileid || messageStatusList.fileId || messageStatusList.FileId || null;
    return { id, fileId };
  }

  // Safely initialize messageArray[1]
  private initializeMessageArrayItem(): void {
    if (!this.messageArray[1]) {
      this.messageArray[1] = {};
    }
    if (!this.messageArray[1].attributes) {
      this.messageArray[1].attributes = [];
    }
  }

  // Map fields from messageStatusList to messageArray[1]
  private mapMessageStatusToArray(messageStatusList: any, fallbackMessageId: string): void {
    const actualMessageId = messageStatusList.messageid || messageStatusList.MessageId || 
                           messageStatusList.id || messageStatusList.Id || fallbackMessageId;
    
    this.messageArray[1].messageid = actualMessageId;
    this.messageArray[1].createddate = messageStatusList.createddate || messageStatusList.CreatedDate;
    this.messageArray[1].messagetype = messageStatusList.messagetype || messageStatusList.MessageType || this.messageArray[1].messagetype;
    this.messageArray[1].mode = messageStatusList.mode || messageStatusList.Mode || this.messageArray[1].mode;
    this.messageArray[1].direction = messageStatusList.direction || messageStatusList.Direction || this.messageArray[1].direction;
    this.messageArray[1].routename = messageStatusList.routename || messageStatusList.RouteName || this.messageArray[1].routename;
    this.messageArray[1].routedefinitionid = messageStatusList.routedefinitionid || messageStatusList.RouteDefinitionId || this.messageArray[1].routedefinitionid;
    this.messageArray[1].transactionid = messageStatusList.transactionid || messageStatusList.TransactionId || this.messageArray[1].transactionid;
    this.messageArray[1].status = messageStatusList.status || messageStatusList.Status || this.messageArray[1].status;
  }

  // Process entity searches from response
  private processEntitySearches(response: any): void {
    if (response.entitySearches && Array.isArray(response.entitySearches)) {
      this.messageArray[1].attributes = response.entitySearches.map((search: any) => ({
        Searchkey: search.Searchkey || search.searchkey,
        SearchValue: search.SearchValue || search.searchValue
      }));
    } else {
      this.ngxUiLoaderService.stop();
      this.messageArray[1].attributes = [];
    }
  }

  // Handle case when no data is found
  private handleNoDataFound(): { id: string | null, fileId: string | null } {
    this.initializeMessageArrayItem();
    this.ngxUiLoaderService.stop();
    this.toastr.warning('Second message details not found', '', {
      timeOut: 4000,
      positionClass: 'toast-bottom-right'
    });
    return { id: null, fileId: null };
  }

  // Handle errors
  private handleError(): { id: string | null, fileId: string | null } {
    this.initializeMessageArrayItem();
    this.ngxUiLoaderService.stop();
    this.toastr.error('Failed to load second message details', '', {
      timeOut: 4000,
      positionClass: 'toast-bottom-right'
    });
    return { id: null, fileId: null };
  }


  copyToClip(event: any, message: string) {
    if (event != "") {
      copyToClipboard(event);
      this.toastr.success(message + " " + "Copied Successfully", "", {
        timeOut: 4000,
        positionClass: "toast-bottom-right",
      });
    }
  }
  
   selectedmessagetype: string = '';
  selectedmessagetypeevent(item) {
    this.selectedmessagetype = item.displayname;
  }
  
   getMessagetypelist(event) {
    const val = event;
    if(val)
    {
    this.isLoadingmessagetype = true;
      this.service.getapiurl("api/Lookup/GetMessageType?lookuptype=messagetype").subscribe({
        next: data => {
          data.forEach(element => {
            this.messageTypeAllList.push({ displayname: element });
          });
          this.messageTypeList = this.messageTypeAllList;

          this.isLoadingmessagetype = false;
          if (data.length == 0) {
            this.notfounddata = true;
          } else {
            this.notfounddata = false;
          }
        },
        error: error => {
          this.isLoadingmessagetype = false;
          this.notfounddata = true;
        }
      });
    }
  }
  
  Clearemessagetype(event) {
    this.selectedmessagetype = '';
    // this.messageTypeList = this.messageTypeAllList;
    this.messageTypeList = [];
    this.messageTypeList = this.messageTypeAllList;
  }

}

